<form *ngIf="form" [formGroup]="form" class="generic-form-fields">
  <dx-text-box formField required formControlName="name" />
  <dx-color-box formControlName="color" formField required [label]="'entity.productBatchState.color' | translate" />
  <dx-check-box
    formControlName="excludeFromStockForecast" formField
    [text]="'entity.productBatchState.excludeFromStockForecast' | translate | ucfirst"
    style="margin: 10px 0 0 10px;"
  />
  <dx-check-box
    formControlName="excludeFromValuedInventory" formField
    [text]="'entity.productBatchState.excludeFromValuedInventory' | translate | ucfirst"
    style="margin: 10px 0 0 10px;"
  />
  <dx-check-box
    formControlName="isBlockedForOperations" formField
    [text]="'entity.productBatchState.isBlockedForOperations' | translate | ucfirst"
    style="margin: 10px 0 0 10px;"
  />
</form>
